<template>
    <autocomplete
        :source="companyList"
        placeholder="Select Company..."
        @selected="handleSelect"
        :value="value"
        style="width:100%;"
        v-model="selectedCompany"
    />
</template>

<script>
import Autocomplete from "vuejs-auto-complete";

export default {
    name: "CompanySelect",
    components: { Autocomplete },
    props: {
        value: String,
        activityId: [String, Number]
    },
    data() {
        return {
            companyList: [],
            selectedCompany: this.value
        };
    },
    watch: {
        selectedCompany(val) {
            this.$emit("input", val);
        },
        activityId: {
            immediate: true,
            handler(newVal) {
                if (!newVal) return;

                const url =
                    newVal == 3
                        ? "/api/getCompaniesForPriceLevelAutoComplete"
                        : newVal == 8
                        ? "/api/getCompaniesForPumaPromoAutoComplete"
                        : "/api/getCompaniesForAutoComplete";

                axios.get(url).then((res) => {
                    this.companyList = res.data.map(c => ({
                        id: c.id,
                        name: c.name
                    }));

                    const match = this.companyList.find(
                        c => String(c.id) === String(this.value)
                    );
                    if (match) this.selectedCompany = match.id;
                });
            }
        }
    },
    methods: {
        handleSelect(item) {
            this.selectedCompany = item.id;
            this.$emit("selected", item);
        }
    }
};
</script>
